
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/alerts",
      function () {
        return require("private-next-pages/user/alerts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/alerts"])
      });
    }
  